import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigService } from 'src/app/shared/services/config.service';

declare let gtag: Function;
@Component({
    selector: 'app-cookie-banner',
    imports: [],
    templateUrl: './cookie-banner.component.html',
    styleUrl: './cookie-banner.component.scss'
})
export class CookieBannerComponent implements OnInit {
    router = inject(Router);
    cookiesStatus = inject(ConfigService).cookiesStatus;
    cookieBannerHidden = inject(ConfigService).cookieBannerHidden;

    constructor() {
        setTimeout(() => {
            this.router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    gtag('config', 'G-79HS72BGQ2', {
                        page_path: event.urlAfterRedirects
                    });
                }
            });
        }, 1);
    }

    ngOnInit(): void {
        this.cookiesStatus.set(localStorage.getItem('cookies') as 'accepted' | 'declined');

        if (!this.cookiesStatus()) {
            this.cookieBannerHidden.set(false);
        } else {
            this.cookieBannerHidden.set(true);
        }

        if (this.cookiesStatus() === 'accepted') {
            gtag('js', new Date());
            gtag('config', 'G-79HS72BGQ2');
        }
    }

    accept() {
        localStorage.setItem('cookies', 'accepted');
        this.cookiesStatus.set('accepted');
        gtag('consent', 'default', {
            analytics_storage: 'granted'
        });
        gtag('js', new Date());
        gtag('config', 'G-79HS72BGQ2');
        this.cookieBannerHidden.set(true);
    }

    decline() {
        localStorage.setItem('cookies', 'declined');
        this.cookiesStatus.set('declined');
        this.cookieBannerHidden.set(true);
    }
}
